import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class CostCenterForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            active:true,
            targets:[],
            search:'',
            name:'',
            users:[],
            selectedUsers:[],
            selectedUsersIds:[]
        };
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.displayUsers = this.displayUsers.bind(this)
        this.handleChangeName = this.handleChangeName.bind(this)
        this.handleTargetChanged = this.handleTargetChanged.bind(this)
        this.addUser = this.addUser.bind(this)
        this.getInitials = this.getInitials.bind(this)
    }

    async componentDidMount() {
        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    if (this.state.selectedUsers.length >= 0) {
                        this.save();
                    } else {
                        swal.fire({
                            text: "Debes seleccionar al menos un usuario",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            }
                        })
                    }
                }
            })
        });

        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
                targets: {
                    validators: {
                        notEmpty: {
                            message: 'Campo requerido'
                        }
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const closeDropdown = e =>{
            this.setState({ users: []});
        }

        document.body.addEventListener('click',closeDropdown)

        return ()=> document.body.removeEventListener('click',closeDropdown)
    }

    addUser(user){
        this.setState({ users: []}, function () {});
        this.selectUser(user)
    }

    getInitials(name){
        const nameList = name.split(' ')
        return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
    }

    async displayUsers(){
        const URL =  `/api/users/search?display=all`
        const membersResponse = await axios.get(URL)
        this.setState({ users: membersResponse.data}, function () {});

        setTimeout(function(){
            this.setState({ users: []})
        }.bind(this), 10000);
    }

    async handleSearchChange(e){
        if(e.target.value != '' ){
            const URL =  `/api/users/search?search=${e.target.value}`
            const membersResponse = await axios.get(URL)
            this.setState({ users: membersResponse.data}, function () {});
        }else{
            this.setState({ users: []})
        }
    }

    handleChangeName(e){
        this.setState({ name:e.target.value})
    }

    selectUser(user){
        let exist = this.state.selectedUsers.filter((u)=>{
            if(u.userId == user.userId){
                return user
            }
        })
        if(exist.length ==0){
            this.setState({ selectedUsers: [...this.state.selectedUsers,user] })
            this.setState({ selectedUsersIds: [...this.state.selectedUsersIds,user.user.id] })
        }
        this.setState({ users: [] })
    }

    handleTargetChanged(e){
        const v = parseInt(e.target.value);
        if (e.target.checked) {
            this.setState(prevState => ({
                targets: [...prevState.targets, v],
            }))
        } else {
            const targets = [...this.state.targets];
            const index = targets.indexOf(v);
            if (index > -1) {
                targets.splice(index, 1);
                this.setState({ targets: targets });
            }
        }
    }

    async save() {
        const { lang } = this.context; 
        window.blockUI(lang.get('messages.procesando')); 
        if (this.state.active) {
            KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        } else {
            KTUtil.btnWait(KTUtil.getById('btnSave'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        }

        const params = JSON.stringify({
            selectedUsers: this.state.selectedUsersIds,
            targets: this.state.targets,
            name: this.state.name
        })

        await axios.post(
            '/api/cost_centers',params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/cost_centers';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        })
    }

    async delete(user) {
        let exist = this.state.selectedUsers.filter((u)=>{
            if(u.userId != user.userId){
                return user
            }
        })

        let exists = this.state.selectedUsersIds.filter((u)=>{
            if(u != user.userId){
                return u
            }
        })

        this.setState({ selectedUsersIds: exists })
        this.setState({ selectedUsers: exist })
    }

    render() {
        const { lang } = this.context;
        return (
            <form id="frm">
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">
                                {lang.get('messages.nuevo_centro_de_costos')}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column-fluid">
                    <div className="container">
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <div className="row justify-content-center text-left">
                                    <div className="col-sm-4 form-group">
                                        <label htmlFor="title" className="text-left">{lang.get('messages.nombre')}</label>
                                        <input id="title" type="text"  value={this.state.name}  onChange={this.handleChangeName} className="form-control form-control-solid" name="name"   required autoFocus  />
                                    </div>
                                    <div className="col-sm-8 form-group">
                                        <label htmlFor="dossier_targets_id " className="text-left">{lang.get('messages.centro_de_costos_para')}:</label>
                                        <div className="checkbox-inline">
                                            { this.props.permissions.targets.includes(2) &&
                                            <label  className="checkbox checkbox-lg checkbox-square">
                                                <input type="checkbox" name="targets" value="2"  onChange={this.handleTargetChanged} />
                                                <span></span>
                                                {lang.get('messages.proveedores')}
                                            </label>
                                            }
                                            { this.props.permissions.targets.includes(3) &&
                                            <label  className="checkbox checkbox-lg checkbox-square">
                                                <input type="checkbox" name="targets" value="3" onChange={this.handleTargetChanged} />
                                                <span></span>
                                                {lang.get('messages.empleados')}
                                            </label>
                                            }
                                            { this.props.permissions.targets.includes(1) &&
                                            <label  className="checkbox checkbox-lg checkbox-square">
                                                <input type="checkbox" name="targets" value="1" onChange={this.handleTargetChanged}  />
                                                <span></span>
                                                {lang.get('messages.clientes')}
                                            </label>
                                            }
                                            { this.props.permissions.targets.includes(4) &&
                                            <label  className="checkbox checkbox-lg checkbox-square">
                                                <input type="checkbox" name="targets" value="4" onChange={this.handleTargetChanged}  />
                                                <span></span>
                                                {lang.get('messages.propios')}
                                            </label>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <p className="font-weight-bold">{lang.get('messages.colaboradores_del_centro_de_costos')}</p>
                                <input id="title" type="text" onClick={()=>{this.displayUsers()}} placeholder={lang.get('messages.buscar_usuarios')} className="form-control form-control-solid col-sm-4" name="title"  autoFocus onChange={this.handleSearchChange}/>
                                <div className="suggestions">
                                {this.state.users.map((u) => {
                                    return(
                                        <div key={u.userId} className="suggestion" onClick={()=>{this.addUser(u)}}>
                                            {u.name}
                                        </div>
                                    )
                                })}
                                </div>
                                <table className="mt-20 table table-borderless table-vertical-center">
                                    <thead>
                                        <tr className="b-bottom">
                                            <td colSpan="2">{lang.get('messages.usuario')}</td>
                                            <td>{lang.get('messages.perfil')}</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.selectedUsers.map((u) => {
                                        return(
                                            <tr key={u.userId}>
                                                <td style={{width: '1%'}}>
                                                    <div className="symbol symbol-40">
                                                        <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                                            {this.getInitials(u.name)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-dark-75 font-weight-bolder font-size-lg"> {u.name}</div>
                                                    <span className="text-dark-50 font-weight-bold font-size-sm"> {u.email}</span>
                                                </td>
                                                <td>
                                                {u.profiles.map((u) => {
                                                    return(
                                                        <div key={u.id} >
                                                            {u.people_profile.name}
                                                        </div>
                                                    )
                                                })}
                                                </td>
                                                <td className="text-right">
                                                <a onClick={()=>{ this.delete(u) }} className="btn btn-xs btn-icon btn-light-secondary mr-4"><i className="flaticon-delete fw-normal text-primary"></i></a>
                                                </td>
                                            </tr>
                                            )
                                        })}
                                        <tr>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-6 text-right">
                                <a href="/cost_centers" className="btn btn-lg btn-secondary">
                                    {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4">
                                    {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default CostCenterForm;

if (document.getElementById('DossierForm')) {
    ReactDOM.render(<CostCenterForm />, document.getElementById('CostCenterForm'));
}
